export default {
  SERVER: {
    MESSAGE: String(1001), // 消息
    ADD_ROOM: String(1002), // 新增房间
    UPDATE_ROOM: String(1003), // 更新房间信息
    DELETE_ROOM: String(1004), // 移除房间
    REFRESH_ROOM_LIST: String(1005), // 刷新房间列表

    ADD_FUBEN: String(1011), // 新增副本
    UPDATE_FUBEN: String(1012), // 更新副本信息
    DELETE_FUBEN: String(1013), // 移除副本
    REFRESH_FUBEN: String(1014), // 刷新副本列表

    ENTER_FUBEN: String(1021), // 进入副本

    ENTER_BATTLE_PAGE: String(1101), // 进入战斗界面
    CONFIRM_MATCH: String(1102), // 确认匹配
    START_BATTLE: String(1103), // 开始战斗
    DO_ACTION: String(1104), // 执行行动
    DO_SPELL: String(1105), // 执行魔法
    NEXT_ACTION: String(1106), // 执行行动
    ENTER_BATTLE_PAGE_WATCH: String(11108), // 进入观战界面
    INIT_WATCH_DATA: String(1109), // 初始化观战数据
    UPDATE_ANIMATION_SPEED: String(1110), // 更换动画速度
    PAGE_BLUR: String(1111), // 页面失去焦点
    AUTO_COMBAT_STATUS_CHANGE: String(1112), // 自动战斗状态更新

    // SCENE
    REFRESH_ONLINE_PLAYERS: String(1201), // 在线玩家
    SCENE_HERO_MOVE: String(1202), // 移动英雄
    SCENE_HERO_OFFLINE: String(1203), // 英雄离开
    VISIT_BUILDING: String(1204), // 访问建筑
  },

  MESSAGE_TYPE: {
    GAME_OVER: String(2001),
    OPPONENT_OFFLINE: String(2002),
    STATUS_ERROR: String(2003),
    DISMISS_ROOM: String(2004),
    SPELL_INVALID: String(2005),
    PVE_GAME_OVER: String(2006),
  },

  CLIENT: {
    GET_ROOM_LIST: String(3001), // 拉取房间列表
    CREATE_ROOM: String(3002), // 创建房间
    JOIN_ROOM: String(3003), // 加入房间
    EXIT_ROOM: String(3004), // 离开房间
    PREPARE: String(3005), // 准备

    ENTER_BATTLE_PAGE: String(3101), // 进入战斗界面
    BATTLE_ACTION: String(3102), // 发起所有战斗行动行为
    BATTLE_SPELL: String(3103), // 发起魔法
    DO_ACTION: String(3104), // 执行行动
    DO_SPELL: String(3105), // 执行魔法
    UPDATE_ANIMATION_SPEED: String(3106), // 更换动画速度
    START_BATTLE: String(3107), // 开始战斗
    NEXT_ACTION: String(3108), // 新ACTION
    PAGE_BLUR: String(3109), // 页面失去焦点
    BATTLE_AUDIO_PLAYED: String(3110), // 战前音乐完毕
    AUTO_COMBAT_ON: String(3111), // 自动战斗开启
    AUTO_COMBAT_OFF: String(3112), // 自动战斗关闭

    ADD_AI_PLAYER: String(3201), // 添加AI玩家
    REMOVE_AI_PLAYER: String(3202), // 移除AI玩家
    CREATURE_SPELL: String(3203), // 生物发起魔法
    JOIN_WATCH: String(3205), // 加入观战
    START_WATCH: String(3206), // 进入观战（战斗中的战役）
    EXIT_WATCH: String(3207), // 退出观战（战斗中的战役）
    UPDATE_FREE_MODE_CONFIG: String(3208), // 更新配置
    CHANGE_TEAM: String(3209), // 更换队伍或位置

    SCENE_HERO_MOVE: String(3301), // 移动英雄
    VISIT_BUILDING: String(3302), // 访问建筑
    SCENE_HERO_MOVE_END: String(3303), // 移动英雄结束

    GET_FUBEN_LIST: String(3401), // 拉取副本列表
    CREATE_FUBEN: String(3402), // 创建副本
    JOIN_FUBEN: String(3403), // 加入副本
    EXIT_FUBEN: String(3404), // 离开副本
    PREPARE_FUBEN: String(3405), // 副本-准备
  },

  CLIENT_ACTION_COMMAND: {
    MOVE: String(4001),
    ATTACK: String(4002),
    DEFEND: String(4003),
    SHOOT: String(4004),
    WAIT: String(4005),
    SPELL: String(4006),
  },

  SERVER_ACTION_COMMAND: {
    MOVE: String(5001),
    ATTACK: String(5002),
    DEFEND: String(5003),
    SHOOT: String(5004),
    WAIT: String(5005),
    RETALIATE: String(5006), // 反击
    WINCE: String(5007), // attacked but did not die
    KILLED: String(5008),
    START_MOVING: String(5009),
    END_MOVING: String(5010),
    ABILITY: String(5011), // 特技
    SPELL: String(5012), // 法术
    CREATURE_SPELL: String(5013), // 生物法术
    MORALE: String(5014), // 士气
    LUCK: String(5015), // 幸运
    BAD_MORALE: String(5016), // 士气低落
    ATTACK_MOVE: String(5017),
    NEXT_TURN: String(5018),
  },

  CHAT: {
    CHAT_HISTORY: String(6001), // 历史记录
    MESSAGE: String(6002), // 聊天消息
    SEND_MESSAGE: String(6003), // 聊天消息
    COMBAT_HISTORY: String(6004), // 战斗消息
    ADD_COMBAT_HISTORY: String(6005), // 新增战斗消息
  },
}
